import React, { useEffect } from "react";

const Page = ({ title, children }) => {
  useEffect(() => {
    document.title = `Roza Venerini | ${title}`;
    window.scrollTo(0, 0);
  }, []);
  return <>{children}</>;
};

export default Page;
